// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

export interface GetResetNotificationsRequestPayload {}

export interface GetResetNotificationsSuccessPayload {
  id: number;
}

export interface GetResetNotificationsFailPayload {
  error: Error;
}

export const getResetNotificationsActions = createAsyncAction(
  'elearning/GET_RESET_NOTIFICATIONS',
  'elearning/GET_RESET_NOTIFICATIONS_SUCCESS',
  'elearning/GET_RESET_NOTIFICATIONS_FAIL'
)<GetResetNotificationsRequestPayload, GetResetNotificationsSuccessPayload, GetResetNotificationsFailPayload>();
